import { defineMessages } from 'react-intl'

export const selectCompanyMessages = defineMessages({
  title: {
    id: 'selectCompanyMessages.title',
    description: 'Heading of the "Select Company" (aka root domain) page',
    defaultMessage: 'Select Company',
  },
})
